import React from "react";
import phone from "../assets/Phone-mockup.png";

export default function Hero() {
  return (
    <section className="hero-section py-5">
      <div className="container">
        <div className="row align-items-center ">

         

          {/* Image */}
          <div className="col-lg-6 text-center mt-5 mt-lg-0">
            <img src={phone} alt="App Preview" className="img-fluid " />
          </div>

           {/* Text */}
          <div className="col-lg-6 text-end text-lg-start">
            <h1 className="fw-bold text-success mb-4 text-end">
              ئەپی یاسا
            </h1>
            <p className="text-muted mb-3 text-end">
             ئەپی یاسا چەتری کۆکەرەی پارێزەرانە لە تەواوی هەرێمی کوردستان
            </p>
                <p className="text-muted mb-4 text-end">
                    دەبێتە دۆزەرەوەی چارەسەری کێشە یاساییەکانت لە یەک خوولەکدا           
                </p>
            <div className="d-flex justify-content-end">
                <button className="btn btn-success ms-lg-3" > <a className="btn btn-success ms-lg-3"  target="_blank"
  rel="noopener noreferrer" href={"https://zanyarfb.github.io/yasa-redirect/"}>دابەزاندن</a></button>
              </div>
          </div>

        </div>
      </div>
    </section>
  );
}
